import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject } from 'rxjs';
import {
  GetEconomicNatureByIdQuery,
  GetEconomicNatureCatalogsQuery,
} from 'src/app/graphql/types';
import { FormValidator } from 'src/app/shared/utils/form-validator';
import { MoneyFormatDirective } from 'src/app/shared/utils/money-format.directive';

import { EconomicNatureService } from '../../../../../services/economic-nature.service';

@Component({
  selector: 'app-economic-nature',
  templateUrl: './economic-nature.component.html',
  styleUrls: ['./economic-nature.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MoneyFormatDirective,
  ],
})
export class EconomicNatureComponent implements OnInit, OnChanges, OnDestroy {
  private fb = inject(FormBuilder);
  private fv = inject(FormValidator);
  private _snackBar = inject(MatSnackBar);
  private _unsubscribeAll!: Subject<any>;
  private economicNatureService = inject(EconomicNatureService);

  @Input() businessUnitId = 0;
  @Input() formData!: GetEconomicNatureByIdQuery & { id: number };
  @Output() formValid = new EventEmitter<{
    status: boolean;
    form: FormGroup;
  }>();
  isLoading = false;
  notification: any = {};
  catalogs!: GetEconomicNatureCatalogsQuery;
  form!: FormGroup;

  ngOnInit(): void {
    this._unsubscribeAll = new Subject<any>();
    this.formInit();
    this.getCatalogs();
    this.form.statusChanges.subscribe(() => {
      this.formValidate();
    });
  }

  ngOnChanges(): void {
    if (this.formData) {
      this.form.patchValue(this.formData);
    }
  }

  private getCatalogs(): void {
    this.economicNatureService.getCatalogs().subscribe(({ data, errors }) => {
      if (data) {
        this.catalogs = data;
      }
      if (errors) {
        this.form.disabled;
      }
    });
  }

  formInit(): void {
    this.form = this.fb.group(
      {
        id: [null],
        architecture: [null, Validators.required],
        prototype: [null, Validators.required],
        sector: [null, Validators.required],
        bancking: [{ value: '1000', disabled: true }],
      },
      { updateOn: 'blur' },
    );
  }

  formValidate() {
    this.formValid.emit({ status: this.form.valid, form: this.form });
  }

  startFormValidator() {
    this.fieldNotificationInit();
  }

  private fieldNotificationInit(): void {
    const fields = {
      architecture: { required: 'Arquitectura es requerido' },
      prototype: { required: 'Prototipo es requerido' },
      sector: { required: 'Sector es requerido' },
    };
    this.fv.setFormValidator(this.form, this.notification, fields);
  }

  //Auxiliar methods
  controlHasError(formControlName: string): boolean {
    return this.fv.fieldHasError(formControlName);
  }

  private openSnack(message: string): void {
    this._snackBar.open(message, '', {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['snack-error'],
      duration: 5000,
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
